module.exports = __webpack_public_path__ + "img/front rise.1573c5d7.png";